import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./StripePaymentResult.css";

export default function PaymentResult() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const paymentIntentId = searchParams.get("payment_intent");

  const eventId = searchParams.get("eventId");

  const [status, setStatus] = useState("verifying"); // verifying | succeeded | failed
  const [message, setMessage] = useState("Verifying your payment...");

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      navigate(`/home/guest`, { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    if (!paymentIntentId) {
      setStatus("failed");
      setMessage("Invalid payment session.");
      return;
    }

    const verifyPayment = async () => {
      try {
        const res = await axios.post("/stripe/confirm-payment", {
          paymentIntentId,
        });

        const statusFromServer = res.data.status;

        if (statusFromServer === "succeeded") {
          setStatus("succeeded");
          setMessage("Payment Successful and Confirmed !!!");

          const eventId = res.data.transaction?.eventId;

          setTimeout(() => {
            if (eventId) {
              navigate(`/eventManagementDetails/${eventId}`, {
                replace: true,
              });
            }
          }, 2500);
        } else if (
          statusFromServer === "requires_capture" ||
          statusFromServer === "processing" ||
          statusFromServer === "requires_confirmation"
        ) {
          setStatus("verifying");

          setTimeout(verifyPayment, 3000); // poll again
        } else if (
          statusFromServer === "canceled" ||
          statusFromServer === "payment_failed"
        ) {
          setStatus("failed");
          setMessage("Payment failed or was canceled.");
        } else {
          setStatus("verifying");
          setTimeout(verifyPayment, 3000);
        }
      } catch (err) {
        // console.error(err);
        setStatus("failed");
        setMessage(
          err?.response?.data?.message ||
            "Payment verification failed. Please contact support."
        );
      }
    };

    verifyPayment();
  }, [paymentIntentId, navigate]);

  return (
    <div className="stripe-payment-result-container">
      <div className={`stripe-payment-result-card ${status}`}>
        {status === "verifying" && <h2>Verifying Payment… ⏳</h2>}
        {status === "succeeded" && <h2>Payment Successful 🎉</h2>}
        {status === "failed" && <h2>Payment Failed ❌</h2>}

        {status !== "verifying" && <p>{message}</p>}

        {status === "succeeded" && (
          <p className="stripe-payment-success">
            Wait while we take you back to event details page.
          </p>
        )}

        {status === "verifying" && (
          <p className="stripe-payment-warning">
            Do not refresh or use the back button while payment is processing.
          </p>
        )}

        {status === "failed" && (
          <button
            onClick={() =>
              navigate(`/eventManagementDetails/${eventId}`, {
                replace: true,
              })
            }
          >
            Back
          </button>
        )}
      </div>
    </div>
  );
}
